import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PageLayout from '@/components/PageLayout';
import ServiceRequestView from '@/components/serviceRequests/ServiceRequestView';
import { useI18n } from '@/i18n/LanguageContext';

const ServiceRequestViewPage: React.FC = () => {
  const { requestId } = useParams<{ requestId: string }>();
  const navigate = useNavigate();
  const { t } = useI18n();

  if (!requestId) {
    return (
      <PageLayout
        title={t('serviceRequest.title') || 'Service Request'}
        showBackButton
        onBack={() => navigate(-1)}
      >
        <div className="flex items-center justify-center p-8">
          <p>{t('serviceRequest.notFound') || 'Service request not found'}</p>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout
      title={t('serviceRequest.title') || 'Service Request'}
      showBackButton
      onBack={() => navigate(-1)}
    >
      <div className="max-w-4xl mx-auto">
        <ServiceRequestView requestId={requestId} />
      </div>
    </PageLayout>
  );
};

export default ServiceRequestViewPage;

